import React from "react";
import { __ } from '@wordpress/i18n';

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;
const arrowRight = `${EASYCOMMERCE.assets}admin/img/icons/arrow-default-right.png`;

const Payment = ({ formValues, setFormValues }) => {
    const handleCurrencyChange = (e) => {
        setFormValues((prev) => ({ ...prev, currency: e.target.value }));
    };

    const handleFormatChange = (e) => {
        setFormValues((prev) => ({ ...prev, format: e.target.value }));
    };
    const handlePaymentMethodToggle = (e) => {
        const methodId = e.target.value;
        const isChecked = e.target.checked;

        setFormValues((prev) => {
            const current = Array.isArray(prev.payment_methods) ? prev.payment_methods : [];
            const updated = isChecked
                ? [...current, methodId]
                : current.filter((m) => m !== methodId);
            return { ...prev, payment_methods: updated };
        });
    };
    const AppPaymentAddons = [
        {
            name: "cod",
            label: "Cash on Delivery",
            type: "free",
        },
        {
            name: "bank-transfer",
            label: "Bank Transfer",
            type: "free",
        },
        {
            name: "stripe",
            label: "Stripe",
            type: "free",
        },
        {
            name: "paypal",
            label: "PayPal",
            type: "free",
        },
        {
            name: "braintree",
            label: "Braintree",
            type: "pro",
            url: "https://easycommerce.dev/addons/easycommerce-braintree",
        },
        {
            name: "mollie",
            label: "Mollie",
            type: "free",
        },
        {
            name: "square",
            label: "Square",
            type: "free",
        },
        {
            name: "paddle",
            label: "Paddle",
            type: "pro",
            url: "https://easycommerce.dev/addons/easycommerce-paddle",
        },
        {
            name: "bkash",
            label: "bKash",
            type: "free",
        },
    ];

    const currencies = {
        AFN: 'Afghan afghani',
        EUR: 'Euro',
        ALL: 'Albanian lek',
        DZD: 'Algerian dinar',
        USD: 'United States dollar',
        AOA: 'Angolan kwanza',
        XCD: 'Eastern Caribbean dollar',
        AAD: 'Antarctican dollar',
        ARS: 'Argentine peso',
        AMD: 'Armenian dram',
        AWG: 'Aruban florin',
        AUD: 'Australian dollar',
        AZN: 'Azerbaijani manat',
        BHD: 'Bahraini dinar',
        BDT: 'Bangladeshi taka',
        BBD: 'Barbadian dollar',
        BYN: 'Belarusian ruble',
        BZD: 'Belize dollar',
        XOF: 'West African CFA franc',
        BMD: 'Bermudian dollar',
        BTN: 'Bhutanese ngultrum',
        BOB: 'Bolivian boliviano',
        BAM: 'Bosnia and Herzegovina convertible mark',
        BWP: 'Botswana pula',
        NOK: 'Norwegian Krone',
        BRL: 'Brazilian real',
        BND: 'Brunei dollar',
        BGN: 'Bulgarian lev',
        BIF: 'Burundian franc',
        KHR: 'Cambodian riel',
        XAF: 'Central African CFA franc',
        CAD: 'Canadian dollar',
        CVE: 'Cape Verdean escudo',
        KYD: 'Cayman Islands dollar',
        CLP: 'Chilean peso',
        CNY: 'Chinese yuan',
        COP: 'Colombian peso',
        KMF: 'Comorian franc',
        NZD: 'New Zealand dollar',
        CRC: 'Costa Rican colón',
        CUP: 'Cuban peso',
        ANG: 'Netherlands Antillean guilder',
        CZK: 'Czech koruna',
        CDF: 'Congolese Franc',
        DKK: 'Danish krone',
        DJF: 'Djiboutian franc',
        DOP: 'Dominican peso',
        EGP: 'Egyptian pound',
        ERN: 'Eritrean nakfa',
        SZL: 'Lilangeni',
        ETB: 'Ethiopian birr',
        FKP: 'Falkland Islands pound',
        FJD: 'Fijian dollar',
        XPF: 'CFP franc',
        GEL: 'Georgian lari',
        GHS: 'Ghanaian cedi',
        GIP: 'Gibraltar pound',
        GTQ: 'Guatemalan quetzal',
        GBP: 'British pound',
        GNF: 'Guinean franc',
        GYD: 'Guyanese dollar',
        HTG: 'Haitian gourde',
        HNL: 'Honduran lempira',
        HKD: 'Hong Kong dollar',
        HUF: 'Hungarian forint',
        ISK: 'Icelandic króna',
        INR: 'Indian rupee',
        IDR: 'Indonesian rupiah',
        IRR: 'Iranian rial',
        IQD: 'Iraqi dinar',
        ILS: 'Israeli new shekel',
        JMD: 'Jamaican dollar',
        JPY: 'Japanese yen',
        JOD: 'Jordanian dinar',
        KZT: 'Kazakhstani tenge',
        KES: 'Kenyan shilling',
        KWD: 'Kuwaiti dinar',
        KGS: 'Kyrgyzstani som',
        LAK: 'Lao kip',
        LBP: 'Lebanese pound',
        LSL: 'Lesotho loti',
        LRD: 'Liberian dollar',
        LYD: 'Libyan dinar',
        CHF: 'Swiss franc',
        MOP: 'Macanese pataca',
        MGA: 'Malagasy ariary',
        MWK: 'Malawian kwacha',
        MYR: 'Malaysian ringgit',
        MVR: 'Maldivian rufiyaa',
        MRO: 'Mauritanian ouguiya',
        MUR: 'Mauritian rupee',
        MXN: 'Mexican peso',
        MDL: 'Moldovan leu',
        MNT: 'Mongolian tögrög',
        MAD: 'Moroccan Dirham',
        MZN: 'Mozambican metical',
        MMK: 'Burmese kyat',
        NAD: 'Namibian dollar',
        NPR: 'Nepalese rupee',
        NIO: 'Nicaraguan córdoba',
        NGN: 'Nigerian naira',
        KPW: 'North Korean Won',
        MKD: 'Denar',
        OMR: 'Omani rial',
        PKR: 'Pakistani rupee',
        PAB: 'Panamanian balboa',
        PGK: 'Papua New Guinean kina',
        PYG: 'Paraguayan guarani',
        PEN: 'Peruvian sol',
        PHP: 'Philippine peso',
        PLN: 'Polish złoty',
        QAR: 'Qatari riyal',
        RON: 'Romanian leu',
        RUB: 'Russian ruble',
        RWF: 'Rwandan franc',
        SHP: 'Saint Helena pound',
        WST: 'Samoan tālā',
        STD: 'Dobra',
        SAR: 'Saudi riyal',
        RSD: 'Serbian dinar',
        SCR: 'Seychellois rupee',
        SLL: 'Sierra Leonean leone',
        SGD: 'Singapore dollar',
        SBD: 'Solomon Islands dollar',
        SOS: 'Somali shilling',
        ZAR: 'South African rand',
        KRW: 'Won',
        SSP: 'South Sudanese pound',
        LKR: 'Sri Lankan rupee',
        SDG: 'Sudanese pound',
        SRD: 'Surinamese dollar',
        SEK: 'Swedish krona',
        SYP: 'Syrian pound',
        TWD: 'New Taiwan dollar',
        TJS: 'Tajikistani somoni',
        TZS: 'Tanzanian shilling',
        THB: 'Thai baht',
        BSD: 'Bahamian dollar',
        GMD: 'Gambian dalasi',
        TOP: 'Tongan paʻanga',
        TTD: 'Trinidad and Tobago dollar',
        TND: 'Tunisian dinar',
        TRY: 'Turkish lira',
        TMT: 'Turkmenistan manat',
        UGX: 'Ugandan shilling',
        UAH: 'Ukrainian hryvnia',
        AED: 'United Arab Emirates dirham',
        UYU: 'Uruguayan peso',
        UZS: 'Uzbekistani soʻm',
        VUV: 'Vanuatu vatu',
        VES: 'Bolívar',
        VND: 'Vietnamese đồng',
        YER: 'Yemeni rial',
        ZMW: 'Zambian kwacha',
        ZWL: 'Zimbabwe Dollar'
      };

    
    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
        >
            <h2 className='text-2xl font-inter text-ec-title font-medium mb-8'>{__('Payment Setup', 'easycommerce')}</h2>
            <div className="w-full">
                <div className="flex flex-col w-full space-y-6">
                    {/* Currency */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={formValues.currency}
                            name="payment-pricing-currency"
                            onChange={handleCurrencyChange}
                        >
                            <option value="">Select Your Currency</option>
                            {Object.keys(currencies).map((code) => (
                                <option key={code} value={code}>
                                {currencies[code]}
                                </option>
                            ))}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency you want to use.
                        </p>
                    </div>

                    {/* Currency Format */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency Format
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={formValues.format}
                            name="payment-pricing-format"
                            onChange={handleFormatChange}
                        >
                            <option value="">Select Your Currency Format</option>
                            {Object.keys(EASYCOMMERCE.currency_format_options).map((format_option) => (
                                <option key={format_option} value={format_option}>
                                    {EASYCOMMERCE.currency_format_options[format_option]}
                                </option>
                            ))}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency format you want to use.
                        </p>
                    </div>

                    {/* Payment Methods */}
                    
                    <div className="flex flex-col">
                        <label className="text-ec-body text-[16px] font-medium">
                            Payment Methods
                        </label>
                        <div className="">
                            {/* {Object.values(EASYCOMMERCE.payment_methods).map((method) => {
                                return (
                                    <div key={method.id} className="flex items-center py-5 gap-3 border-b border-ec-table-stock">
                                        <input
                                            name="payment-methods-active_methods"
                                            type="checkbox"
                                            id={method.id}
                                            value={method.id}
                                            checked={formValues.payment_methods.includes(method.id)}
                                            onChange={(e) => handlePaymentMethodToggle(e)}
                                            className="easycommerce-checkbox-input"
                                        />
                                            <label
                                            htmlFor={method.id}
                                            className="flex items-center cursor-pointer text-ec-body text-[16px]"
                                        >
                                            <span className="capitalize">{method.title}</span>
                                        </label>
                                    </div>
                                );
                            })} */}
                            {AppPaymentAddons.map(({ name, label, type, url }) => {
                                const addonSlug = `easycommerce-${name}`;
                                const checked = formValues.payment_methods.includes(addonSlug);
                                const isPro = type === "pro";

                                return (
                                    <div
                                        key={addonSlug}
                                        className={`group flex items-center py-5 gap-3 border-b border-ec-table-stock ${isPro ? 'border-[#EBEBEB]' : ''}`}
                                    >
                                        <input
                                            name="payment-methods-active_methods"
                                            type="checkbox"
                                            id={addonSlug}
                                            value={addonSlug}
                                            checked={checked}
                                            onChange={handlePaymentMethodToggle}
                                            className={`easycommerce-checkbox-input ${isPro ? 'border-ec-border' : ''}`}
                                            disabled={isPro}
                                        />
                                        <label
                                            htmlFor={addonSlug}
                                            className="flex items-center cursor-pointer"
                                        >
                                            <span className={`text-ec-body text-[16px] ${isPro ? 'text-ec-wizard' : ''}`}>{label}</span>
                                        </label>
                                        {isPro && (
                                            <a 
                                                href={url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-[40px] group-hover:w-[54px] text-[#272435] focus:shadow-none flex items-center gap-0 text-ec-warning text-sm hover:text-sm pl-2 group-hover:pl-2 group-hover:px-2 py-[2px] bg-[#F9A00080] group-hover:bg-[#F9A000] rounded-full transition-all duration-200 transform group-hover:scale-110"
                                            >
                                                Pro
                                                <img
                                                    src={arrowRight}
                                                    alt="Pro Arrow"
                                                    className="w-3 h-2 inline ml-0 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 ease-out group-hover:translate-x-1"
                                                />
                                            </a>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Payment;
